import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DialogModule } from '@libs/shared/components/dialog/dialog.module';
import { ButtonModule } from '@libs/shared/components/button/button.module';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-removing-account-dialog',
  templateUrl: './removing-account-dialog.component.html',
  styleUrls: ['./removing-account-dialog.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [DialogModule, ButtonModule, TranslateModule],
})
export class RemovingAccountDialogComponent {
  constructor(public dialogRef: MatDialogRef<RemovingAccountDialogComponent>) {}
}
